import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as ecModels from '../../../../models'
import type { Plugin } from '../plugin'

/**
 * TODO: (this might need to be split into multiple effects) intelligently
 * figures out what to do when the params change. Often this will just be
 * emitting load (probably not through a relay), but sometimes this may do
 * things like sort or filter on the frontend, or if there is
 * noBackendPagination and we already have the full list, we may not do anything
 * at all.
 */
export const triggerLoad = store.effects.create(
  <TTypeParams extends ecModels.TypeParams.Constraint>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    rxjs
      .merge(
        // When the entity collection is ready
        plugin.collection.ready$,
        // Or the query request changes
        feature.selectors.queryRequest.asObservable,
      )
      .pipe(
        rxjsUtils.delayUntil(plugin.collection.ready$, { maxDelayed: 1 }),
        rxjs.map(() =>
          feature.actions.load.from('triggerLoad (effect)').create(),
        ),
      ),
)
